<template>
  <!-- 生产单详情-生产单表头部分 -->
  <el-descriptions
    border
    size="medium"
    column="4"
    labelStyle="width: 100px"
    contentStyle="width: 250px"
  >
    <el-descriptions-item label="部门">{{
      workOrderHeader.department
    }}</el-descriptions-item>
    <el-descriptions-item label="工单编号">{{
      workOrderHeader.number
    }}</el-descriptions-item>
    <el-descriptions-item label="制单日期">{{
      workOrderHeader.createTime
    }}</el-descriptions-item>
    <el-descriptions-item label="状态">{{
      workOrderHeader.status_change
    }}</el-descriptions-item>

    <el-descriptions-item label="机台">{{
      workOrderHeader.machineNumber
    }}</el-descriptions-item>
    <el-descriptions-item label="机台型号">{{
      workOrderHeader.machineType
    }}</el-descriptions-item>
    <el-descriptions-item label="胚布编号">{{
      workOrderHeader.craftsheet.number
    }}</el-descriptions-item>

    <el-descriptions-item label="上机状态">{{
      workOrderHeader.workStatus_change
    }}</el-descriptions-item>
    <el-descriptions-item label="胚布名称">{{
      workOrderHeader.craftsheet.name
    }}</el-descriptions-item>

    <el-descriptions-item label="幅宽"
      >{{ workOrderHeader.combs }} 厘米</el-descriptions-item
    >
    <el-descriptions-item label="幅数"
      >{{ workOrderHeader.combsCount }} 幅</el-descriptions-item
    >
    <el-descriptions-item label="车速"
      >{{ workOrderHeader.speed }} 转/分钟</el-descriptions-item
    >
    <el-descriptions-item label="针密"
      >{{ workOrderHeader.density }} 针/cm</el-descriptions-item
    >
    <el-descriptions-item label="平方克重"
      >{{ workOrderHeader.squareGrams }} g/m2</el-descriptions-item
    >
    <el-descriptions-item label="匹长"
      >{{ workOrderHeader.dropClothLength_change }} 米</el-descriptions-item
    >
    <el-descriptions-item label="生产长度"
      >{{
        workOrderHeader.predictProducedLength_change
      }}
      米</el-descriptions-item
    >
    <el-descriptions-item label="生产重量"
      >{{ workOrderHeader.predictWeight }} 千克</el-descriptions-item
    >

    <el-descriptions-item label="完成重量"
      >{{ workOrderHeader.nowWeight }} 千克</el-descriptions-item
    >
    <el-descriptions-item label="针数">{{
      workOrderHeader.threadCount
    }}</el-descriptions-item>

    <el-descriptions-item label="组织纱丝号">{{
      workOrderHeader.silkNumber
    }}</el-descriptions-item>
    <el-descriptions-item label="完成长度"
      >{{ workOrderHeader.nowProducedLength_change }} 米</el-descriptions-item
    >

    <el-descriptions-item label="备注">{{
      workOrderHeader.remark
    }}</el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  data() {
    return {
      workOrderHeader: {
        craftsheet: {}, // 防止console中多余的告警。
      },
    };
  },
  methods: {
    // 设置表头信息
    setworkOrderHeader(response) {
      this.workOrderHeader = this.formatworkOrderHeader(response);
    },
    // 格式化表单信息
    formatworkOrderHeader(res) {
      res.createTime = this.utils.timestampToTime(res.createTime);
      res.department = "生产部"; // 暂时先固定为 '生产部'.
      res.density = Number(res.density).toFixed(2); // 浮点数强制显示2位小数。

      // 匹长. 前端是'米'，后台是'厘米'，提交时*100，显示时/100。
      res.dropClothLength_change = res.dropClothLength / 100;

      res.predictWeight = Number(res.predictWeight/1000).toFixed(2); // 浮点数强制显示2位小数。
      // 已完成. 前端是'米'，后台是'厘米'，提交时*100，显示时/100。
      res.nowProducedLength_change = Number(
        res.nowProducedLength / 100
      ).toFixed(2); // 浮点数强制显示2位小数。
      // 目标产量输入时是米，要转换成厘米，后台是按整数(厘米)存储。
      res.predictProducedLength_change = Number(
        res.predictProducedLength / 100
      ).toFixed(2);
      res.speed = Number(res.speed).toFixed(2); // 浮点数强制显示2位小数。
      res.squareGrams = Number(res.squareGrams).toFixed(2); // 浮点数强制显示2位小数。

      // status 0=审核不通过(待修改), 1=未审核(待审核), 2=已审核, , 3=结案。
      if (res.status === 3) {
        res.status_change = "结案";
      } else if (res.status === 2) {
        res.status_change = "已审核";
      } else if (res.status === 1) {
        res.status_change = "待审核";
      } else {
        // 0 或者 null
        res.status_change = "待修改";
      }

      res.threadCount = Number(res.threadCount).toFixed(2); // 浮点数强制显示2位小数。

      // workStatus 上机状态
      // 0 = 准备中  ---->添加工单时，不显示。
      // 1 = 待产    ---->提交工单后，显示 "就绪"="等待"。
      // 3 = 生产中  ---->点击上单后，显示 "上单"="上机"
      // 2 = 暂停    ---->点击下单后，显示 "下单"="下机"
      // 4 = 完成    ---->后台自动切换，显示 "关闭"
      if (res.workStatus === 1) {
        if (res.status === 2) {
          //已审核
          res.workStatus_change = "就绪";
        } else {
          res.workStatus_change = "";
        }
      } else if (res.workStatus === 2) {
        res.workStatus_change = "下单";
      } else if (res.workStatus === 3) {
        res.workStatus_change = "上单";
      } else if (res.workStatus === 4) {
        res.workStatus_change = "关闭";
      } else {
        // 0 或者 null
        res.workStatus_change = "准备中";
      }

      return res;
    },
  },
};
</script>

<style lang="scss" scoped></style>
